<div id="search">
    <input id="type" (keyup)="onKey($event)" placeholder="BUSCAR">
    <button id="lupa" (click)="searchProduct()"><img src="/assets/images/magnify.svg"></button>
</div>

<div *ngIf="loading"  id="loa"> 
   
      <img id="rotate" src="/assets/images/loading.svg">
</div>
<bm-category categoryName="{{category}}" [products]="products"></bm-category>